import $ from 'jquery';
import {LOADING_CLASS_NAME} from '../constants';

$(document).ready(() => {

  const inputSelector = '.number .number__val';

  $(document).on('click', '.cart__remove', cartRemoveHandler);
  $(document).on('click', '.number__minus', numberMinusClickHandler);
  $(document).on('click', '.number__plus', numberPlusClickHandler);
  $(document).on('updated', inputSelector, quantityUpdatedHandler);
  $(document).on('input blur change', inputSelector, inputValueChanged);

  let timer;
  const delay = 1000; //time between keypresses
  function inputValueChanged(e) {
    var _this = $(this);
    clearTimeout(timer);
    timer = setTimeout(function() {
      _this.trigger('updated', [_this]);
    }, delay );
  };

  function cartRemoveHandler(e) {
    e.preventDefault();
    e.stopPropagation();
    removeFromCart(e.currentTarget);
  }

  function numberMinusClickHandler(e) {
    e.preventDefault();
    const input = $(e.currentTarget).closest('.number').find('.number__val');
    let val = +input.val();
    if (val <= 1) {
      return; //do nothing whern value equals to 1
    }
    val--;
    input.val(val);

    clearTimeout(timer);
    timer = setTimeout(function() {
      input.trigger('updated', [input]);
    }, delay );
  }

  function numberPlusClickHandler(e) {
    e.preventDefault();
    const input = $(e.currentTarget).closest('.number').find('.number__val');
    let val = +input.val();
    val++;
    input.val(val);
    clearTimeout(timer);
    timer = setTimeout(function() {
      input.trigger('updated', [input]);
    }, delay );
  }

  function quantityUpdatedHandler(event, sender)
  {
    const quantity = sender.val();
    if (quantity >= 1) {
      updateCartPromise()
        .then((result) => {
          getCartData();
        })
        .catch((e) => {
          console.log('Error occured while updateing cart.');
        });

    }
  }

  function updateCartPromise() {
    let $form = getForm();
    onFormUpdateStarted();
    let data = $form.serialize();

    return $.post('/ajax/cart/save', data)
      .always(() => {
        onFormUpdateDone();
      })

    return new Promise(
      (resolve, reject) => {
        try {
          $form.submit();

          setTimeout(function() {
            resolve();
          }, 500 )

          // resolve();

        } catch (e) {
          onFormUpdateDone();
          reject(e);
        }
      })
  }

  function removeFromCart(element)
  {
    onFormUpdateStarted();
    const url = $(element).attr('data-delete-url');
    $.ajax({
      url: url,
      method: 'DELETE',
      success: function (jqXHR, textStatus) {
        getCartData().then((data) => {
          $(element).closest('tr').remove();
        });
      },
      error : function(jqXHR, textStatus, errorThrown) {
        onFormUpdateDone();
      }
    });
  }

  function getCartData()
  {
    const $form = getForm();
    const url = '/ajax/cart';
    return $.ajax({
      url: url,
      method: 'GET',
      success: function (data, textStatus) {
        if(!data.items) {
          window.location.reload();
          return;
        } else {
          updateCartView(data);
        }

        onFormUpdateDone();
      },
      error : function(jqXHR, textStatus, errorThrown) {
        onFormUpdateDone();
      }
    });
  }

  function updateCartView(data) {
    $('[data-role=cart-total]').text(data.total_formatted);
    for(var index in data.items) {
      var product = data.items[index];
      $('[data-index='+index+'] [data-role=item-total]').text(product.total_formatted);
    };
  }

  function getForm()
  {
    return $('form[name=sylius_cart]')
  }

  function onFormUpdateStarted()
  {
    const $form = getForm();
    $form.addClass(LOADING_CLASS_NAME);
  }

  function onFormUpdateDone()
  {
    const $form = getForm();
    $form.removeClass(LOADING_CLASS_NAME);
  }

});




// WEBPACK FOOTER //
// ./frontend/src/cart/cart.js